export var PNL_TRANSACTION_REPORT = "PNL_TRANSACTION_REPORT";
export var STOCK_DETAILS_SUMMARY = "STOCK_DETAILS_SUMMARY";
export var PNL_TRANSACTION_ERROR = "PNL_TRANSACTION_ERROR";
export var PNL_TRANSACTION_HIDE_ERROR = "PNL_TRANSACTION_HIDE_ERROR";
export var PNLTXN_EMPTY_VALIDATION = "PNLTXN_EMPTY_VALIDATION";
export var PNLTXN_HIDE_EMPTY_VALIDATION = "PNLTXN_HIDE_EMPTY_VALIDATION";
export var PNL_TRANSACTION_SHOW_SHIMMER = "PNL_TRANSACTION_SHOW_SHIMMER";
export var EDIT_SPLIT_TXN_LOADER = "EDIT_SPLIT_TXN_LOADER";
export var PNL_ORIGINAL_TXNS = "PNL_ORIGINAL_TXNS";
export var PNL_ORIGINAL_TXNS_LOADER = "PNL_ORIGINAL_TXNS_LOADER";
